import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Splash from './pages/splash';
import Intro from './pages/intro';
import Home from './pages/home';
import LevelSelection from './pages/level_selection';
import Level1 from './pages/level_1';
import Level2 from './pages/level_2';
import Level3 from './pages/level_3';
import EndlessRoomLevel from './pages/endless_room_level';
import Layout from './components/layout';

const UNLOCKED_LEVEL_KEY = 'unlocked_level';

const AppRoutes = () => {
  const location = useLocation();
  const [showSettings, setShowSettings] = useState(false);
  const [showBonus, setShowBonus] = useState(() => localStorage.getItem('bonus_claimed') !== 'true');
  const [moneyCount, setMoneyCount] = useState(1250);
  const [unlockedLevel, setUnlockedLevel] = useState(() => (
    Number(localStorage.getItem(UNLOCKED_LEVEL_KEY)) || 1
  ));

  useEffect(() => {
    localStorage.setItem(UNLOCKED_LEVEL_KEY, unlockedLevel);
  }, [unlockedLevel]);

  const unlockLevel = (level) => {
    setUnlockedLevel((currentLevel) => Math.max(currentLevel, level));
  };

  return (
    <Layout
      hide_music={location.pathname === '/' || location.pathname === '/levels' || showSettings || (location.pathname === '/home' && showBonus)}
    >
      <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/intro" element={<Intro />} />
        <Route path="/home" element={<Home showSettings={showSettings} setShowSettings={setShowSettings} showBonus={showBonus} setShowBonus={setShowBonus} moneyCount={moneyCount} setMoneyCount={setMoneyCount} />} />
        <Route path="/levels" element={<LevelSelection unlockedLevel={unlockedLevel} />} />
        <Route path="/level_1/*" element={<Level1 showSettings={showSettings} setShowSettings={setShowSettings} unlockLevel2={() => unlockLevel(2)} moneyCount={moneyCount} setMoneyCount={setMoneyCount} />} />
        <Route path="/level_2/*" element={<Level2 showSettings={showSettings} setShowSettings={setShowSettings} unlockLevel3={() => unlockLevel(3)} moneyCount={moneyCount} setMoneyCount={setMoneyCount} />} />
        <Route path="/level_3/*" element={<Level3 showSettings={showSettings} setShowSettings={setShowSettings} unlockLevel4={() => unlockLevel(4)} />} />
        <Route path="*" element={<EndlessRoomLevel showSettings={showSettings} setShowSettings={setShowSettings} unlockLevel={unlockLevel} moneyCount={moneyCount} setMoneyCount={setMoneyCount} />} />
      </Routes>
    </Layout>
  );
}

const Routing = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default Routing;
